// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-template-item-page-js": () => import("./../../../src/templates/template-item-page.js" /* webpackChunkName: "component---src-templates-template-item-page-js" */),
  "component---src-templates-template-page-js": () => import("./../../../src/templates/template-page.js" /* webpackChunkName: "component---src-templates-template-page-js" */)
}

